import { render, staticRenderFns } from "./AIChat.vue?vue&type=template&id=cacacf8a&"
import script from "./AIChat.vue?vue&type=script&lang=js&"
export * from "./AIChat.vue?vue&type=script&lang=js&"
import style0 from "./AIChat.vue?vue&type=style&index=0&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports